<ion-header class="ion-no-border ion-header-modal-mobile" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="back-modal-btn"
        text=""
        (click)="navigateBack()"
      >
      </ion-back-button>
    </ion-buttons>
    <ion-label>
      {{ data.title }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div>
    <ion-label *ngIf="!isTouch">{{ data.title }}</ion-label>
    <ion-list>
      <ng-container *ngIf="data.canSelectMultiple || hasManyOptions">
        <ion-item class="select-all">
          <ion-label>
            {{
              (isAllSelected
                ? 'i18n.common.deselectAll'
                : 'i18n.common.selectAll'
              ) | translate
            }}
          </ion-label>
          <ion-checkbox
            mode="ios"
            slot="end"
            [checked]="isAllSelected"
            (ionChange)="selectAllChanged($event)"
          ></ion-checkbox>
        </ion-item>
      </ng-container>
      <ion-item *ngFor="let option of data.data | keyvalue: mapOrder">
        <ion-label>
          {{ option.value }}
        </ion-label>
        <ion-checkbox
          mode="ios"
          slot="end"
          [checked]="data.newSelectedData.includes(option.key)"
          (ionChange)="optionSelectionChanged($event, option.key)"
        ></ion-checkbox>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="save-modal-btn"
        data-cy="save-modal-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="navigateBack()"
        translate
      >
        {{ 'i18n.common.save' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
